import script from "./VideoControls.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoControls.vue?vue&type=script&setup=true&lang=js"

import "./VideoControls.vue?vue&type=style&index=0&id=7c687f5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c687f5a"]])

export default __exports__